<template>
  <div v-if="ot">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('addEditOrdreTravailTech.patrimoine.addDemandeToOt.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button class="button" @click="$router.go(-1)">
                {{$t('general.button.return')}}
              </button>
              <button class="button is-addOrEdit mgl-10px" @click="selectDemande()">
                {{$t('general.button.add')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline mgt-20px level">
      <div class="level-left">
        <div class="column is-narrow">
          <form @submit.prevent="recherche()">
            <b-input :placeholder="$t('general.button.search')"
                     type="search"
                     icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
        </div>
        <div class='column is-narrow'>
          <button class="button" @click='showFiltre = !showFiltre'>
            <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
            <span class="is-size-7">{{$t('general.button.filtre')}}</span>
          </button>
          <div class="info-circle-right background-primary is-pulled-right"
               v-if="getFilteredNumber > 0">
            <span class="inside-circle">{{ getFilteredNumber }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="tableWithPerPageSelection">
      <v-server-table url="" :columns="columns" :options="options" ref="tableIntervention"
                      @loaded="finLoading" @loading="debutLoading">
        <template slot='afterTable'>
          <table-items-in-view @input="$refs.tableIntervention.setLimit($event)"/>
        </template>
        <div slot="selected" slot-scope="props" class="has-text-centered">
          <b-checkbox :value="isSelect(props.row.id)"
                      @input="selectDemandeId(props.row)"/>
        </div>
        <div slot="etat" slot-scope="props">
          {{ getLibelleEtatDemande(props.row.etat) }}
        </div>
        <div slot="dateSouhaite" slot-scope="props">
          {{ props.row.datePlanification | formatDate }}
        </div>
        <div slot="creationTime" slot-scope="props">
          {{ props.row.creationTime | formatDate }}
        </div>
        <div slot="demandeur" slot-scope="props">
          {{ getUser(props.row.demandeurId) }}
        </div>
        <div slot="source" slot-scope="props">
          {{ $t(getSourceTraduction(props.row.source)) }}
        </div>
        <div slot="actionLogistique" slot-scope="props">
          <b-tooltip :label="props.row.actionLogistique"
                     type="is-primary" multilined
                     position="is-bottom">
            <p class="ellipsis"> {{ props.row.actionLogistique }}</p>
          </b-tooltip>
        </div>
        <div slot="demandeLie" slot-scope="props">
          <a class="lien" v-if="props.row.demandesLogistiqueEnfant.length > 0"
             @click="setDemandeEnfantAndOpenPopUp(props.row.demandesLogistiqueEnfant)">
            {{ $t('listeIntervention.actions.voirDemandeEnfant',
            { nombre: props.row.demandesLogistiqueEnfant.length }) }}
          </a>
          <p v-else> {{ $t('listeIntervention.tab.aucun') }} </p>
        </div>
        <div slot="typeOt" slot-scope="props">
          {{ getLibelleTypeOT(props.row.typeOtId) }}
        </div>
      </v-server-table>
    </div>
    <b-modal v-model="openPopUpVisu" has-modal-card class="modal">
      <visualisation-demande-lie :demandesInterventionEnfant="demandesEnfant"/>
    </b-modal>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-if="showFiltre">
        <filtre-liste-intervention v-if="showFiltre" @toggleFiltre="showFiltre = !showFiltre"
                                   @recherche="makeRechercheFilter"
                                   :value="critereRecherche"/>
      </div>
    </transition>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import genererCritereRechercheIntervention from '@/services/logistique/intervention/genererCritereRechercheIntervention';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import tableItemsInView from '@/components/general/TableItemsInView';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import formatIsoDate from '@/services/general/formatIsoDate';
import breadcrumb from '@/components/general/breadcrumb';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import visualisationDemandeLie from '@/components/logistique/intervention/liste/p_visualisationDemandeLie';
import {
  ETAT_DEMANDE_INTERVENTION,
  INTERVENTION_TYPE_INTERVENTION,
  SOURCE_INTERVENTION,
  ETAT_TRAITE,
  ETAT_VALIDE,
} from '@/configuration/logistique/intervention/interventionConf';
import messageErreur from '@/services/general/messageErreur';
import filtreListeIntervention from '@/components/logistique/intervention/liste/filtreListeIntervention';

const Societe = createNamespacedHelpers('societe');
const OT = createNamespacedHelpers('ordreTravailTech');
const Intervention = createNamespacedHelpers('intervention');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      showFiltre: false,
      ot: null,
      critereRecherche: genererCritereRechercheIntervention(),
      demandesEnfant: [],
      openPopUpVisu: false,
    };
  },
  components: {
    breadcrumb,
    tableItemsInView,
    visualisationDemandeLie,
    filtreListeIntervention,
  },
  computed: {
    ...OT.mapGetters({
      otCourant: 'ordreTravailTechCourant',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Intervention.mapGetters({
      interventions: 'items',
      totalCount: 'total',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    allInterventionSelected() {
      return this.getAllInterventionSelected.length === this.interventions.length
        && this.interventions.length > 0;
    },
    iconSelectTotal() {
      if (this.allInterventionSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    columns() {
      return ['selected', 'etat', 'code', 'creationTime', 'actionLogistique', 'adresse', 'dateSouhaite', 'typeOt', 'demandeur', 'source', 'demandeLie'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          etat: this.$t('listeIntervention.tab.etat'),
          code: this.$t('listeIntervention.tab.numeroDemande'),
          creationTime: this.$t('listeIntervention.tab.date'),
          actionLogistique: this.$t('listeIntervention.tab.sujet'),
          adresse: this.$t('listeIntervention.tab.patrimoine'),
          dateSouhaite: this.$t('listeIntervention.tab.dateSouhaite'),
          demandeur: this.$t('listeIntervention.tab.demandeur'),
          source: this.$t('listeIntervention.tab.source'),
          typeOt: this.$t('listeIntervention.tab.typeOt'),
          demandeLie: this.$t('listeIntervention.tab.demandeLie'),
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.critereRecherche);
          data.query.agencesIds = [this.ot.agenceId];
          data.query.types = [INTERVENTION_TYPE_INTERVENTION];
          if (this.ot.id) data.query.otIds = [null, this.ot.id];
          else data.query.otIds = [null];
          data.query.societeId = this.ot.societeId || this.societeActiveId;
          if (data.query.dateCreationTime.dateDebut && data.query.dateCreationTime.dateFin) {
            data.query.dateCreationTime.dateDebut = formatIsoDate(
              data.query.dateCreationTime.dateDebut,
            );
            data.query.dateCreationTime.dateFin = formatIsoDate(
              data.query.dateCreationTime.dateFin,
            );
          }
          if (data.query.datePlanification.dateDebut && data.query.datePlanification.dateFin) {
            data.query.datePlanification.dateDebut = formatIsoDate(
              data.query.datePlanification.dateDebut,
            );
            data.query.datePlanification.dateFin = formatIsoDate(
              data.query.datePlanification.dateFin,
            );
          }
          return this.loadIntervention(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.interventions,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          selected: 'colonneSelected',
          actionLogistique: 'planningTailleColonneLibelleNumerique',
        },
        sortable: ['etat', 'code', 'creationTime', 'actionLogistique', 'adresse', 'dateSouhaite', 'type', 'source'],
      };
    },
    getAllInterventionSelected() {
      return this.interventions.filter((el) => {
        return this.ot.demandesLogistiqueIds.find((id) => {
          return id === el.id;
        });
      });
    },
    getFilteredNumber() {
      const banCritere = ['auto', 'dateCreationTime', 'datePlanification', 'types', 'sansParent', 'agencesIds'];
      let nbFiltre = calculNombreCritere(this.critereRecherche, banCritere);
      if (this.critereRecherche.dateCreationTime.dateDebut
        && this.critereRecherche.dateCreationTime.dateFin) {
        nbFiltre += 1;
      }
      if (this.critereRecherche.datePlanification.dateDebut
        && this.critereRecherche.datePlanification.dateFin) {
        nbFiltre += 1;
      }
      return nbFiltre > 9 ? '9+' : nbFiltre;
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('addEditOrdreTravailTech.breadcrumb.liste'), route: { name: 'l.logistique.ordre_travail-tech' }, isActive: false },
        { title: this.$i18n.t('addEditOrdreTravailTech.breadcrumb.add'), route: { name: 'm.logistique.ordre_travail-techAdd' }, isActive: false },
        { title: this.$i18n.t('addEditOrdreTravailTech.patrimoine.addDemandeToOt.breadcrumb.add'), route: '', isActive: true },
      ];
      if (this.ot && this.ot.id) {
        output[2].title = this.$i18n.t('addEditOrdreTravailTech.breadcrumb.edit');
        output[2].route = { name: 'm.logistique.ordre_travail-techEdition', params: { id: this.ot.id } };
      }
      return output;
    },
  },
  methods: {
    ...Intervention.mapActions({
      loadIntervention: 'loadIntervention',
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametres: 'loadParametres',
    }),
    ...OT.mapActions({
      setOtCourant: 'setOtCourant',
    }),
    selectAll() {
      if (this.allInterventionSelected) {
        this.ot.demandesLogistiqueIds = [];
        this.ot.demandesLogistique = [];
      } else {
        this.ot.demandesLogistiqueIds = this.interventions.map((int) => int.id);
        this.ot.demandesLogistique = cloneDeep(this.interventions);
      }
    },
    getLibelleEtatDemande(etatConstante) {
      const etatFind = ETAT_DEMANDE_INTERVENTION.find((etat) => {
        return etat.key === etatConstante;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
    selectDemandeId(demande) {
      const isSelect = this.isSelect(demande.id);
      if (isSelect) {
        const index = this.ot.demandesLogistiqueIds.findIndex((id) => {
          return id === demande.id;
        });
        if (index === -1) return;
        this.ot.demandesLogistiqueIds.splice(index, 1);
        const indexInDemande = this.ot.demandesLogistique.findIndex((d) => {
          return d.id === demande.id;
        });
        this.ot.demandesLogistique.splice(indexInDemande, 1);
      } else {
        this.ot.demandesLogistiqueIds.push(demande.id);
        this.ot.demandesLogistique.push(demande);
      }
    },
    isSelect(idDemande) {
      return !!this.ot.demandesLogistiqueIds.find((id) => {
        return idDemande === id;
      });
    },
    recherche() {
      this.$refs.tableIntervention.refresh();
    },
    makeRechercheFilter(criteres) {
      this.critereRecherche = cloneDeep(criteres);
      this.recherche();
    },
    setDemandeEnfantAndOpenPopUp(demandes) {
      this.demandesEnfant = demandes;
      this.openPopUpVisu = true;
    },
    selectDemande() {
      this.setOtCourant(this.ot);
      this.$router.go(-1);
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    getUser(userId) {
      const userFind = this.parametre(PARAMETRES_KEYS.utilisateur).find((user) => {
        return user.id === userId;
      });
      return userFind ? userFind.decorator.nomPrenom : '';
    },
    getLibelleTypeOT(typeOtId) {
      const typeFind = this.parametre(PARAMETRES_KEYS.typeOt).find((type) => {
        return type.id === typeOtId;
      });
      return typeFind ? typeFind.libelle : null;
    },
    getSourceTraduction(sourceKey) {
      const source = SOURCE_INTERVENTION.find((source) => {
        return source.key === sourceKey;
      });
      if (!source) return null;
      return source.libelle;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!['m.logistique.ordre_travail-techAdd', 'm.logistique.ordre_travail-techEdition'].includes(to.name)) {
      this.setOtCourant(null);
    }
    next();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.critereRecherche.etats = [ETAT_VALIDE, ETAT_TRAITE];
      if (this.otCourant.typeOtId) this.critereRecherche.typeOtIds = [this.otCourant.typeOtId];
      this.ot = cloneDeep(this.otCourant);
      if (!this.ot) this.$router.go(-1);
      this.setInformationPage(this.$t('pageLogistique.ot.listeAjoutDemande'));
      await this.loadParametres([PARAMETRES_KEYS.typeOt]);
      await this.loadParametreUtilisateur();
      loadingComponent.close();
    } catch (error) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw error;
    }
  },
};

</script>
